import React, { useEffect, useState } from 'react';
import { getLang } from '../i18n';

const API_URL = process.env.REACT_APP_API_URL || '/api';
const FALLBACK_REVIEW_URL = 'https://g.page/r/CYSQIA_qXafTEBM/review';
const FALLBACK_PROFILE_URL = 'https://www.google.com/maps/search/?api=1&query=YourGermanAddress';
const ui = (de, en) => (getLang() === 'en' ? en : de);

function ReviewActions({ profileUrl, reviewUrl }) {
  return (
    <div className="google-review-summary__actions">
      <a className="secondary-button" href={profileUrl} target="_blank" rel="noreferrer">
        {ui('Bewertungen auf Google ansehen', 'View reviews on Google')}
      </a>
      <a className="primary-link-button" href={reviewUrl} target="_blank" rel="noreferrer">
        {ui('Ehrlich auf Google bewerten', 'Leave an honest Google review')}
      </a>
    </div>
  );
}

function GoogleReviewSummary({ compact = false }) {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    let active = true;
    fetch(`${API_URL}/feedback/google-summary`)
      .then((response) => response.json())
      .then((data) => { if (active) setSummary(data); })
      .catch(() => {
        if (active) setSummary({ available: false, profile_url: FALLBACK_PROFILE_URL, review_url: FALLBACK_REVIEW_URL });
      });
    return () => { active = false; };
  }, []);

  if (!summary) return null;
  const profileUrl = summary.profile_url || summary.source_url || FALLBACK_PROFILE_URL;
  const reviewUrl = summary.review_url || FALLBACK_REVIEW_URL;

  if (!summary.available) {
    return (
      <section className={`google-review-summary ${compact ? 'is-compact is-dashboard-highlight' : ''}`} aria-labelledby="google-review-heading">
        <span className="eyebrow">Google</span>
        <h3 id="google-review-heading">{ui('Erfahrungen unserer Kundschaft', 'Customer experiences')}</h3>
        <p>{ui(
          'Lesen Sie Erfahrungen auf unserem offiziellen Google-Profil oder teilen Sie freiwillig Ihre ehrliche Meinung.',
          'Read customer experiences on our official Google profile or voluntarily share your honest opinion.'
        )}</p>
        <ReviewActions profileUrl={profileUrl} reviewUrl={reviewUrl} />
      </section>
    );
  }

  return (
    <section className={`google-review-summary ${compact ? 'is-compact is-dashboard-highlight' : ''}`} aria-labelledby="google-review-heading">
      <div className="google-review-summary__header">
        <div><span className="eyebrow">Google</span><h3 id="google-review-heading">{ui('Aktuelle Kundenbewertungen', 'Current customer reviews')}</h3></div>
        <div className="google-review-summary__aggregate" aria-label={ui(
          `${Number(summary.rating).toFixed(1)} von 5 Sternen bei ${summary.review_count} Bewertungen`,
          `${Number(summary.rating).toFixed(1)} out of 5 stars from ${summary.review_count} reviews`
        )}>
          <strong>{Number(summary.rating).toFixed(1)} / 5</strong>
          <span>{ui(`${summary.review_count} Bewertungen`, `${summary.review_count} reviews`)}</span>
        </div>
      </div>
      {!compact && summary.reviews?.length ? (
        <div className="google-review-summary__list">
          {summary.reviews.map((review, index) => (
            <blockquote key={`${review.google_uri || 'review'}-${index}`}>
              <span aria-label={ui(`${review.rating} von 5 Sternen`, `${review.rating} of 5 stars`)}>{'★'.repeat(review.rating)}</span>
              <p>{review.text}</p>
              {review.relative_time ? <small>{review.relative_time}</small> : null}
            </blockquote>
          ))}
        </div>
      ) : null}
      <p className="google-review-summary__source">{ui(
        'Quelle: Google Places; ohne Namen oder Profilbilder dargestellt.',
        'Source: Google Places; displayed without names or profile images.'
      )}</p>
      <ReviewActions profileUrl={profileUrl} reviewUrl={reviewUrl} />
    </section>
  );
}

export default GoogleReviewSummary;
